import { render, staticRenderFns } from "./InternalNavAnchorsItem.vue?vue&type=template&id=06455ade&"
import script from "./InternalNavAnchorsItem.vue?vue&type=script&lang=js&"
export * from "./InternalNavAnchorsItem.vue?vue&type=script&lang=js&"
import style0 from "./InternalNavAnchorsItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports